import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=1181e4df&scoped=true"
import script from "./radio.vue?vue&type=script&lang=ts"
export * from "./radio.vue?vue&type=script&lang=ts"
import style0 from "./radio.vue?vue&type=style&index=0&id=1181e4df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1181e4df",
  null
  
)

export default component.exports